<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div style="display: flex; justify-content: flex-start;">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
          <div class="main" ref="element" style="text-align: center;">
            <img height="1" width="1" style="border-style:none; display:none;" alt="" :src="skySrc" v-if="skySrc !== ''"/>
            <div style="color:#4F4C4C;">
              <!--未支付订单取消成功 开始-->
              <div v-if="OrderCancelSuccessDiv" class="StatusDiv">
                <div class="order-cancel-status-img">
                  <img style="width: 100px; height: 100px;" src="https://res.roompai.com/static/img/order/orderCancelSuccess.png">
                </div>
                <div class="reserve-text-one">{{$t('cancelSuccess')}}</div>
                <div class="reserve-text-two">
                  {{$t('bookingReference')}}：<span style="color:#5392F9;">{{orderno}}</span>
                </div>
                <div style="margin: 60px 0;">
                  <el-button class="booknow_button float-none" @click="cityRouterLink" style="width: auto;">Home</el-button>
                  <el-button class="white_button" @click="lookMyBook">Review booking</el-button>
                </div>
              </div>
              <!--未支付订单取消成功 结束-->
              <!--成功 开始-->
              <div v-if="SuccessDiv" class="StatusDiv">
                <div class="order-status-img">
                  <img style="width: 100%;" src="/static/img/account/my-payment-yes.png">
                </div>
                <div class="reserve-text-one">Confirmed</div>
                <div class="reserve-text-two">Booking reference: <span style="color:#5392F9;">{{orderno}}</span></div>
                <div class="reserve-text-two">
                  Booking confirmation will be sent to your email (<span style="color:#5392F9;">{{userEmail}}</span>) within 10 minutes.
                </div>
                <div style="margin: 60px 0;">
                  <el-button class="booknow_button float-none" @click="cityRouterLink" style="width: auto;">Home</el-button>
                  <el-button class="white_button" @click="lookMyBook">Review booking</el-button>
                </div>
              </div>
              <!--成功 结束-->
              <!--失败 开始-->
              <div v-if="FailedDiv" class="StatusDiv">
                <div class="order-status-img" style="background:rgb(217, 0, 27);">
                  <img style="width:50px; height:50px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
                </div>
                <div class="reserve-text-one">Failed</div>
                <div class="fail-reserve-text-two">
                  {{$t('noRooms')}}
                </div>
                <div style="margin: 60px 0;">
                  <router-link :to="{ name: 'HotelDetail',  query: { 'hotelid': paramsArr.hotelid, 'region': paramsArr.region, 'start_date': paramsArr.checkin, 'end_date': paramsArr.checkout, 'room': paramsArr.room, 'adult': paramsArr.adult, 'child': paramsArr.childNums} }">
                    <el-button class="booknow_button float-none" @click="cityRouterLink" style="width: auto;">Other</el-button>
                  </router-link>
                  <el-button class="white_button" @click="cityRouterLink">Home</el-button>
                </div>
              </div>
              <!--失败 结束-->
              <!--待确认 开始-->
              <div v-if="WaitConfirmationDiv" class="StatusDiv">
                <div style="display:block;">
                  <img src="/static/img/account/waitconfirmation.png" style="width:80px; height:80px;">
                </div>
                <div class="reserve-text-one">
                  <div style="display:inline-block;">{{$t('pending')}}</div>
                  <div style="display:inline-block;width:0px">
                    <el-popover popper-class="popverText" placement="left" trigger="click">
                      <div style="font-size:12px;">
                        <div v-html="$t('pendingMeanBookingnotCompleteYouBookingHotel')"></div>
                        <div>{{$t('limitedInventoriesAndBestPrice')}}</div>
                        <div v-if="language === 'zh'">{{$t('hotelAndYouWillReceiveFinalBookingStatusInboxLeft')}}{{minutes}}{{$t('hotelAndYouWillReceiveFinalBookingStatusInboxRight')}}</div>
                        <div v-else>{{$t('hotelAndYouWillReceiveFinalBookingStatusInboxLeft')}} {{minutes}} {{$t('hotelAndYouWillReceiveFinalBookingStatusInboxRight')}}</div>
                      </div>
                      <img src="https://res.roompai.com/static/img/order/tanhao.png" style="width:12px; height:12px; cursor: pointer; margin-bottom: 7px;" slot="reference">
                    </el-popover>
                  </div>
                </div>
                <div class="reserve-text-two" v-if="orderno !== ''">
                  {{$t('bookingReference')}}：<span style="color:#5392F9;">{{orderno}}</span>
                </div>
                <div class="reserve-text-two" v-if="paymentSecondConfirm === '1' && paypalEmail !== ''">
                  {{$t('bookingPendingPaymentSecondConfirm')}} {{paypalEmail}} {{$t('bookingPendingPaymentSecondConfirmTwo')}}
                </div>
                <div class="reserve-text-two" v-else>
                  {{$t('bookingIsPendingWekeepYouInformedMinutesLeft')}} {{minutes}} {{$t('bookingIsPendingWekeepYouInformedMinutesRight')}}
                </div>
                <div class="reserve-text-two" v-if="userEmail !== ''">
                  {{$t('bookingStatusWilBeSendToYourEmail')}}: <span style="color:#5392F9;">{{userEmail}}</span>
                </div>
                <div style="margin: 60px 0;">
                  <el-button class="booknow_button float-none" @click="cityRouterLink" style="width: auto;">Home</el-button>
                  <el-button class="white_button" @click="lookMyBook">Review booking</el-button>
                </div>
              </div>
              <!--待确认 结束-->

              <!--未查到订单 开始-->
              <div v-if="FindOrderErrorDiv" class="StatusDiv">
                <div class="order-status-img" style="background:red;">
                  <img style="width:50px; height:50px;margin: 15px;" src="https://res.roompai.com/static/img/account/my-error.png">
                </div>
                <div class="reserve-text-one">
                  <div style="display:inline-block;">{{$t('noOrderFound')}}</div>
                </div>
                <div class="reserve-text-two">
                  {{$t('norefundContactUs')}}
                </div>
                <div style="margin: 60px 0;">
                  <el-button class="booknow_button" @click="cityRouterLink" style="width: auto; float: none;">Home</el-button>
                </div>
              </div>
              <!--未查到订单 结束-->

              <!--待支付 开始-->
              <div v-if="toBePaidDiv" class="StatusDiv">
                <div style="display:block;">
                  <img src="/static/img/order/waitconfirmation.png" style="width:80px; height:80px;">
                </div>
                <div class="reserve-text-one">
                  <div style="display:inline-block;">{{$t('unpaid')}}</div>
                </div>
                <div class="reserve-text-two" v-if="orderno !== ''">
                  {{$t('bookingReference')}}：<span style="color:#5392F9;">{{orderno}}</span>
                </div>
                <div class="reserve-text-two">
                  {{$t('ToBePaidStatusWaitPatiently')}}
                </div>
                <div class="reserve-text-two" >
                  {{$t('norefundContactUs')}}
                </div>
                <div style="margin: 60px 0;">
                  <el-button class="booknow_button float-none" @click="cityRouterLink" style="width: auto; margin-right: 60px;">Home</el-button>
                  <el-button class="white_button" @click="lookMyBook">Review booking</el-button>
                </div>
              </div>
              <!--待支付 结束-->

              <!--支付失败 开始-->
              <div v-if="PaymentFailedDiv" class="StatusDiv">
                <div style="display:block;">
                  <img src="/static/img/order/payDisabled.png" style="width:80px; height:80px;">
                </div>
                <div class="reserve-text-one">
                  {{ $t('payDisabled') }}
                </div>
                <div class="reserve-text-two">
                  <div>Your booking failed because your payment was declined. Please verify your account information or try using a different account to complete the payment. If you continue to experience issues, please contact our customer service for assistance. </div>
                </div>
              </div>
              <!--支付失败 结束-->
            </div>
          </div>
        </el-main>
      </slot>
      <publicFooter :source="source"></publicFooter>
    </div>
  </div>
  </el-container>
</template>
<script>
import { downloadTrip, orderPayCallbackResultShow } from '@/request/order.js'
import html2pdf from 'html2pdf.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
export default {
  name: 'PayCallbackResult',
  components: {
    publicFooter,
    publicHeader,
    publicMenu
  },
  data () {
    return {
      curPageData: 'PayCallbackResult',
      currencyShow: false, // 币种是否显示
      OrderCancelSuccessDiv: false,
      SuccessDiv: false,
      FailedDiv: false,
      WaitConfirmationDiv: false,
      FindOrderErrorDiv: false,
      PaymentFailedDiv: false,
      toBePaidDiv: false,
      orderno: '',
      ordernoUnLogin: '',
      hotelid: '',
      callback: '',
      userEmail: '',
      paramsArr: {},
      tripPdfInformation: {},
      orderDetail: [],
      hotelDetail: [],
      elementHeight: document.body.clientHeight - 350,
      city: {},
      cityname: '',
      language: this.common.languageSet(this),
      minutes: 60,
      contactInfo: {},
      skySrc: '',
      paypalEmail: '',
      paymentSecondConfirm: 0,
      isCollapse: this.common.collapseSet(),
      contentWidth: document.body.clientWidth - 74,
      personWidth: (document.body.clientWidth - 74) * 0.2182 - 10,
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''},
      toPay: false,
      source: this.common.sourceSet()
    }
  },
  created () {
    this.payResult()
  },
  watch: {
    language: function (newCur, oldCur) {
      this.payResult()
    }
  },
  mounted: function () {
    this.source = this.common.sourceSet()
    var source = this.common.sourceSet()
    // 过期时间 5个小时
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
      var sourceExpiresAt = Date.now() + 3600000 * 5
      localStorage.setItem('source', this.source)
      localStorage.setItem('sourceExpiresAt', sourceExpiresAt)
    } else {
      source = this.$route.query.source
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime > sourceExpires) {
          localStorage.removeItem('source')
          localStorage.removeItem('sourceExpiresAt')
        } else {
          // 避免手动干预删除或者修改localStorage
          if (source === '' || source === undefined || source === null) {
            localStorage.removeItem('source')
            localStorage.removeItem('sourceExpiresAt')
          } else {
            this.source = source
            this.common.sourceSet(source)
          }
        }
      }
    }
    if (this.source === '' || this.source === undefined || this.source === null) {
      let locationHref = window.document.location.href
      localStorage.setItem('LoginWebsiteAddress', locationHref)
      this.$router.push({name: 'login'})
    }
  },
  methods: {
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    hotelLanguage (language) {
      this.language = language
    },
    payResult: function () {
      let locationHref = window.document.location.href
      var query = this.$route.query

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var currency = this.common.currencySet(this)
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)

      this.orderno = query.orderno
      this.hotelid = query.hotelid
      this.callback = query.callback

      // 订单结果数据
      var orderResultJson = {
        'token': token,
        'time': time,
        'orderno': query.orderno,
        'currency': currency,
        'operation': 'orderPayCallbackResultShow'
      }
      var orderResultShow = this.common.encryptionData(orderResultJson, this)
      // 1-待支付 2-待确认 3-已确认 4-已取消 5-拒单
      orderPayCallbackResultShow(orderResultShow).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else if (res.flag === '003') {
          this.FindOrderErrorDiv = true
        } else if (['200'].includes(res.flag)) {
          this.orderno = res.data.orderno
          this.ordernoUnLogin = res.data.ordernoUnLogin
          this.userEmail = res.data.email
          this.minutes = res.data.minutes
          this.city = res.data.hotelData.hotelCity
          if (this.language === 'zh') {
            this.cityname = this.city.chinese_name
          } else {
            this.cityname = this.city.city
          }
          this.paypalEmail = res.data.paypalEmail
          this.paymentSecondConfirm = res.data.paymentSecondConfirm
          if (['3'].includes(res.data.orderStatus)) {
            this.SuccessDiv = true
          } else if (['2'].includes(res.data.orderStatus)) {
            this.WaitConfirmationDiv = true // 待确认产品
          } else if (['4'].includes(res.data.orderStatus)) {
            this.OrderCancelSuccessDiv = true
          } else if (['5'].includes(res.data.orderStatus)) {
            this.FailedDiv = true
          } else {
            if (this.callback === '169') {
              this.toPay = true
              this.toBePaidDiv = true
            } else if (this.callback === '168') {
              this.PaymentFailedDiv = true
            } else {
              this.WaitConfirmationDiv = true
            }
          }
        }

        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderResultShow, res, requestTime, responseTime)
        })
      })
    },
    JumpHomePage () {
      this.$router.push('WritePay')
    },
    cityRouterLink: function () {
      // 点击返回首页 埋点记录
      this.clickPageAction('back_home', '', {'type': 'PayCallbackResult'})

      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }

      let d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth()
      var tian = d.getDate()
      var monthSelect = (month + 1) < 10 ? '0' + (month + 1).toString() : (month + 1).toString()
      var startDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 1)
      var endDate = year + '-' + monthSelect + '-' + (parseInt(tian) + 2)

      // 无母房型有报价
      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': 1, 'adult': 2, 'child': 0}
      localStorage.setItem('searchData', JSON.stringify(searchJson))

      this.$router.push({name: 'HotelList', query: searchJson})
    },
    downloadPdf () {
      // 获取数据
      if (this.orderno === undefined) {
        return false
      }
      var time = parseInt(new Date().getTime() / 1000)
      var token = localStorage.getItem('token')
      if (token === undefined) {
        let locationHref = window.document.location.href
        sessionStorage.setItem('LoginWebsiteAddress', locationHref)
        this.$router.push({name: 'login'})
      }
      var sessionid = this.common.sessionidGet(this)
      var dataJson = {
        'orderno': this.orderno,
        'time': time,
        'token': token,
        'sessionid': sessionid
      }
      var data = this.common.encryptionData(dataJson, this)
      console.log(data)
      downloadTrip(data).then(res => {
        console.log(res)
        if (res.flag === '001') {
          let locationHref = window.document.location.href
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else if (res.flag === '200') {
          this.hotelDetail = res.data.hotelDetail
          this.orderDetail = res.data.orderDetail
          this.tripPdfInformation = {'Booking reference': this.orderDetail.orderno, 'Creation date': this.orderDetail.create_date, 'Hotel': this.hotelDetail.hotelname, 'Address': this.hotelDetail.hoteladdress, 'Property Contact Number': this.hotelDetail.tel, 'Lead guest': this.orderDetail.leadguest}
          let data = Object.assign({}, this.$refs)
          html2pdf(data.pdfDom, {
            margin: 1,
            filename: this.orderno + '.pdf',
            image: {
              type: 'jpeg',
              quality: 1
            },
            html2canvas: {
              scale: 2
            },
            jsPDF: {
              unit: 'pt',
              format: 'a4',
              orientation: 'landscape'
            }
          })
        }
      })
    },
    lookMyBook () {
      this.source = this.common.sourceSet()
      // 点击完成 埋点记录
      this.clickPageAction('view_book', '', {'orderno': this.orderno})
      if (this.toPay === false) {
        this.$router.push({name: 'tripDetail', query: {'orderno': this.ordernoUnLogin !== '' ? this.ordernoUnLogin : this.orderno, 'source': this.source}})
      } else {
        this.$router.push({name: 'WritePay', query: {'orderno': this.ordernoUnLogin !== '' ? this.ordernoUnLogin : this.orderno, 'source': this.source, 'showCancel': 1}})
      }
    }
  }
}
</script>

<style scoped>
.el-main {background-color: rgba(242, 242, 242, 1);color: #4F4C4C;text-align: center;line-height:35px;}
.main {width:1500px;margin: 0 auto;height:100vh;display: flex;justify-content: center;align-items: center;}
.reserve-text-one {font-size: 22px;font-style: normal;font-weight:650;}
.reserve-text-two{font-size: 14px;}
.fail-reserve-text-two{font-size: 16px;}
.pay_button{cursor:pointer; width: auto !important; font-size:14px; margin: 0px 6px;text-decoration:none;}
.pay_button:hover,.pay_button:focus{background-color:rgba(79, 76, 76, 1);color: rgb(252, 210, 5);border: solid 1px rgba(221, 223, 226, 1);}

.home_button{background-color:rgba(79, 76, 76, 1);color: rgb(252, 210, 5);}
.home_button a{color: rgb(252, 210, 5);}
.travel_button{background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.travel_button a{color:#4F4C4C;}
/* .StatusDiv{max-width:750px;} */
.float-none {float: none !important;}
.travel_button a:hover{color: rgb(252, 210, 5);}
.travel_button:focus{background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.pay_button_fail{/*width:48%;*/height:36px;background-color:rgba(79, 76, 76, 1);color: rgb(252, 210, 5);border:none;font-size:14px; border:none;border-radius:4px; margin: 0px 6px; margin-top:10%;text-decoration:none;}
.home_button_fail{width:40%;height:36px;font-size:14px; border:none;border-radius:4px; margin-right:4%; margin-top:10%;text-decoration:none;background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.popverText{ font-size:12px;width:20%;}

.fail-reserve-text-payerror-two{font-weight: 650; font-size: 22px; color: #4F4C4C;}
.contact-info{font-size: 14px;text-align: left; line-height: 20px; margin-top: 25px;width: 350px;}

.order-cancel-status-img{width: 100px; height: 100px; border-radius: 50%; margin: 0px auto 0px;}
.order-status-img{width: 80px; height: 80px; border-radius: 50%; margin: 0px auto 20px;}
@media screen and (max-width: 1500px) {
.main {width:95%;}
.pay_button, .home_button_fail{width:90%; margin-top: 10px;}
.pay_button_fail{width:90%;}
}
</style>
<style lang="scss">
  /* 下载行程单 */
  .pdf{width:1080px;height:auto;font-size:14px; margin: 0 auto;}
  .pdf-main{width:100%;margin: 20px 0px;border:1px solid rgba(79, 76, 76, 1);height: 100%;}
  .pdf-logo{width: 193px;height: 32px; margin:10px 0px;}
  .score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
  .scoreNo{height: 6px;border-radius: 100px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
  .scoreYes{height: 100%;text-align: right;border-radius: 100px;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
  .logo-text{font-weight: 650;font-style: normal;font-size: 22px;color: #333;display: inline-block;float: right;height: 53px;line-height: 53px;width:250px;}
  /* .tr td{text-align:center;} */
  .pdf-content{margin-top:10px;}
  .pdf-information{height:28px; line-height: 28px;}
  .pdf-information-top{margin-top:10px;}
  .pdf-title{font-weight: 500;font-size: 18px;border-bottom: 1px solid rgba(215, 215, 215, 1);height: 34px;line-height: 34px;}
  .information-left{width:40%;height:100%;float:left;}
  .information-right{width:60%;height:100%;float:left;}
  .pdf-content th{font-weight: 400; color:#333; font-size: 14px;}
  .pdf-content .el-table th.el-table__cell.is-leaf{border-bottom: 1px solid #EBEEF5;}
  .pdf-content .el-table td.el-table__cell{border-bottom:none;}
  .pdf-payment{ float: left; width:48%; height:130px;}
  .pdf-payment-info{height:28px; line-height: 28px; width:100%;}
  .payment-left{width:70%; float:left;}
  .payment-right{width:30%; float:left;}
  .pdf-payment-right{ float:right; width:48%; height:110px; background-color: rgba(221, 223, 226, 0.2980392156862745); line-height: 22px;padding: 10px;}
  .pdf-policy-text{ height:28px; line-height:28px;}
  .policy-remarks{ background-color: rgba(221, 223, 226, 0.2980392156862745);line-height: 22px;padding: 10px 0;}
  .pdf-contact-right{float:right; width:48%; height:130px;line-height: 25px;}
  .pdf-notice div{line-height:28px;}
  </style>



// WEBPACK FOOTER //
// src/components/order/PayCallbackResult.vue